import { createFileRoute } from '@tanstack/react-router';
import { DealPageWrapper } from '..';

export const Route = createFileRoute(
  '/(authenticated)/$hub/deal/$shortId/$title/',
)({
  component: DealPageWrapper,
  staticData: {
    keepAlive: true,
  },
});
